import brochures from "../../../assets/Brochures.jpg";
import card from "../../../assets/card.jpg";
import booklets from "../../../assets/Booklets.jpg";
import invoice from "../../../assets/invoice.jpg";
import printing from "../../../assets/Printing.jpg";

export const sliderImage = [
  {
    title: "Third Slide",
    description: "This is the Third slider Image of our carousel",
    urls: card,
  },
  {
    title: "Third Slide",
    description: "This is the Third slider Image of our carousel",
    urls: brochures,
  },
  {
    title: "Third Slide",
    description: "This is the Third slider Image of our carousel",
    urls: booklets,
  },
  {
    title: "Second Slide",
    description: "This is the second slider Image of our carousel",
    urls: invoice,
  },
  {
    title: "First Slide",
    description: "This is the first slider Image of our carousel",
    urls: printing,
  },
];
